goog.provide("shadow.js.shim.module$src$svg$artwork$hourglass_svg");
goog.provide("module$shadow_js_shim_module$src$svg$artwork$hourglass_svg");
shadow.js.shim.module$src$svg$artwork$hourglass_svg = shadow.js.nativeProvides["src/svg/artwork/hourglass.svg"] = shadow$bridge("src/svg/artwork/hourglass.svg");
module$shadow_js_shim_module$src$svg$artwork$hourglass_svg.default = shadow.js.shim.module$src$svg$artwork$hourglass_svg;
